import React, { useEffect, useState } from 'react'
import styles from './EnvironmentVariantItem.module.scss'
import clsx from 'clsx';
import { getPlayCanvasStringValue } from '../../../../../../utils/functions/getPlayCanvasStringValue';
import { useAppSelector } from '../../../../../../redux/store';
import { getEnvironmentActiveValues } from '../../../../../../redux/reducers/ui/uiSelectors';

export const EnvironmentVariantItem = ({proxyVariant, proxyName, onChangePlaycanvasSetting}: any) => {
  const {image, name, id, playcanvasString} = proxyVariant;
  const [isShowDetailTooltip, setIsShowDetailTooltip] = useState(false);
  const [activeVariant, setActiveVariant] = useState<any>()
  const environmentActiveValues = useAppSelector(getEnvironmentActiveValues);

  useEffect(() => {
    if(proxyName && environmentActiveValues && environmentActiveValues.length){
      const activeEnv = environmentActiveValues.find((env) => env.proxyName === proxyName)

      if(activeEnv) setActiveVariant(activeEnv.proxyValue)
    }
  }, [environmentActiveValues, proxyName]) 
  // const [isActive, setIsActive] = useState<boolean>(false);
  // @ts-ignore
  // const windowPlay = window.containerRef.current.contentWindow.VividMaterialAPI

  // useEffect(() => {
  //   let currentOption: any = "";

  //   const objects = windowPlay.findAllChangers();
  //   if(Array.isArray(objects) && objects.length) {
  //     currentOption = objects.find((option) => option.name.toLowerCase().includes(proxyName.toLowerCase()))
  //   }
  //   const activeCanvasValue = windowPlay.getValueMaterail(currentOption?.name, proxyName).name;

  //   if(activeCanvasValue) {
  //     setIsActive(activeCanvasValue === name)
  //   }
  // }, [])

  // const handleSetPlaycanvasValue = () => {
  //   let currentOption: any = "";

  //   const objects = windowPlay.findAllChangers();
  //   if(Array.isArray(objects) && objects.length) {
  //     currentOption = objects.find((option) => option.name.toLowerCase().includes(proxyName.toLowerCase()))
  //   }
    
  //   if (currentOption?.name && proxyName && id) {
  //     windowPlay.setValueName(currentOption?.name, proxyName, name)

  //     const activeCanvasValue = windowPlay.getValueMaterail(currentOption?.name, proxyName).name;

  //     if(activeCanvasValue) {
  //       setIsActive(activeCanvasValue === name)
  //     }
  //   }
  // }

  const handleClickVariant = () => {
    onChangePlaycanvasSetting({variantId: id, variantName: name, nodeName: getPlayCanvasStringValue(playcanvasString)})
  }

  return (
    image ? (
      <button
        key={name}
        className={clsx({[styles.item]: true, [styles.active]: activeVariant === name} )}
        onClick={handleClickVariant}
        onMouseEnter={() => setIsShowDetailTooltip(true)}
        onMouseLeave={() => setIsShowDetailTooltip(false)}
      >
        {isShowDetailTooltip ? (
          <div className={styles.tooltip}>
            {name}
          </div>
        ) : null}
        <div className={styles.img_wrapper}>
          <img src={image} alt="proxyOptionVariant" />
        </div>
      </button>
    ) : (
    <button
      key={name}
      className={clsx({[styles.item_name]: true, [styles.active]: activeVariant === name} )}
      onClick={handleClickVariant}
      >
      {name}
    </button>
    )
  )
}
